import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";
import { NavigationItem } from "./NavigationItem";
import styles from "./LeftNavigation.module.scss";
import Cookies from "js-cookie";
import {
  ListCircle,
  List,
  CheckmarkDone,
  ChevronForward,
  LockOpen,
  NotificationsCircle,
  ArrowUp,
} from "react-ionicons";

export interface NavigationMenuItem {
  title: string;
  icon: React.ReactNode;
  path: string;
  allowedRoles: string[];
}

const getNavigationList = (
  t: TFunction<"translation">
): Array<NavigationMenuItem> => [
  {
    title: "List of applicants",
    icon: <ListCircle />,
    path: "/admin/listofapplicants",
    allowedRoles: [
      "ADM",
      "BUS",
      "SOC",
      "REG",
      "TOU",
      "NUR",
      "AVP",
      "NUI",
      "POT",
      "REO",
      "MOC",
      "SPN",
      "HDP",
      "FIN",
      "HDM",
      "MAS",
    ],
  },
  {
    title: "Ranking list",
    icon: <List />,
    path: "/admin/rankingList",
    allowedRoles: ["ADM", "REG", "AVP"],
  },
  {
    title: "Accepted to major",
    icon: <CheckmarkDone />,
    path: "/admin/acceptedmajor",
    allowedRoles: ["ADM", "REG", "AVP", "FIN"],
  },
  {
    title: "Assigend to interview",
    icon: <ChevronForward />,
    path: "/admin/assignedtoInterview",
    allowedRoles: ["ADM", "REG", "AVP", "NUI", "POT"],
  },
  {
    title: "Open/Close applications",
    icon: <LockOpen />,
    path: "/admin/applications",
    allowedRoles: ["ADM", "FIN"],
  },
  {
    title: "Eng. placement",
    icon: <ArrowUp />,
    path: "/admin/exam",
    allowedRoles: ["ADM", "AVP", "ENG"],
  },
  {
    title: "Notification templetes",
    icon: <NotificationsCircle />,
    path: "/admin/notificationtempletes",
    allowedRoles: ["ADM", "REG", "AVP", "NUI", "POT", "FIN", "ENG"],
  },
];

export const LeftNavigation = ({
  opened,
}: {
  opened: boolean;
}): JSX.Element => {
  const { t } = useTranslation();

  const [selectedIndex, setSelectedIndex] = useState(0);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const base = `${pathname.slice(1).split("/").shift()}`;

  const onNavigationSelect = (path: string, index: number) => {
    navigate(path);
    setSelectedIndex(index);
  };

  const isItemSelected = (path: string, index: number): boolean => {
    return path === base || (base === "" && index === selectedIndex);
  };
  const role = Cookies.get("role");

  return (
    <div className={styles["left-navigation"]}>
      {getNavigationList(t).map((item, index) => {
        return (
          <>
            {item.allowedRoles.includes(role ?? "") ? (
              <NavigationItem
                key={`navMenu_${index}`}
                {...item}
                opened={opened}
                isSelected={isItemSelected(item.path, index)}
                onSelect={() => {
                  onNavigationSelect(item.path, index);
                }}
              />
            ) : null}
          </>
        );
      })}
    </div>
  );
};
